/**
 * THE status pill — one shape and one type weight for every status badge
 * (orders, hires, tasks, gags), so they cannot drift (owner, 2026-10-03:
 * "make them share a common component").
 *
 * 📱 Below md the text is font-normal (owner, same day: "a less bold text"
 * → "try removing the semi bold"); desktop keeps font-semibold.
 *
 * Colour is the CALLER's: pass the status's existing colour classes
 * (`STATUS_COLORS`, `TASK_STATUS_COLORS`, `GAG_STATUS_COLORS`, a hire badge's
 * bg + text). The pill never decides what a status means.
 */
import React from 'react';

export const STATUS_PILL_WEIGHT = 'font-semibold max-md:font-normal';

/** The pill's own classes (shape, size, weight) — for a call site that must
 *  build its own element (e.g. a truncating hire cell). */
// 📱 Default size below md: 11px, tighter padding (owner 2026-10-03: "still too
// prominent" — a label, a touch smaller than the 12px row text).
export const statusPillClass = (size) => `rounded-full ${STATUS_PILL_WEIGHT} ${size === 'md' ? 'px-3 py-1 text-sm' : 'px-2 py-0.5 text-xs max-md:text-[11px] max-md:leading-4 max-md:px-1.5 max-md:py-0'}`;

export default function StatusPill({ label, colorClass = '', size, className = '', ...rest }) {
  return (
    <span className={`inline-flex items-center ${statusPillClass(size)} ${colorClass} ${className}`.trim()} {...rest}>
      {label}
    </span>
  );
}
